import { CloneEffect } from 'src/app/admin/clone-user/store/effects/clone.effect';

export const CloneUserEffects = [CloneEffect];
